import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'trial-ended',
  async getComponent () {
    const {
      default: TrialEndedContainer
    } = await import(/* webpackChunkName: "trial-ended-container" */ './containers/TrialEndedContainer')
      .catch(handleChunkLoadError);
    return TrialEndedContainer;
  },
  getData ({ context }) {
    return context.props;
  }
});
